import { render, staticRenderFns } from "./online_users.vue?vue&type=template&id=23135579&scoped=true"
import script from "./online_users.vue?vue&type=script&lang=ts"
export * from "./online_users.vue?vue&type=script&lang=ts"
import style0 from "./online_users.vue?vue&type=style&index=0&id=23135579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23135579",
  null
  
)

export default component.exports